export default {
    data: function () {
        return {
            //
        }
    },
    methods: {
        zindexUp: function () {
            EaseEventBus.fire('zindexUp', {
                id: this.index
            });
        },
        zindexDown: function () {
            EaseEventBus.fire('zindexDown', {
                id: this.index
            });
        }
    }
};
